/** A project batch saved some projects before a later request failed. */
export class ProjectBatchOperationError extends Error {
  /**
   * Records completed projects so callers can retry only the remaining selection.
   * @param {unknown} cause The failed request.
   * @param {string[]} completedProjectIds Projects already saved by the server.
   */
  constructor(
    cause: unknown,
    readonly completedProjectIds: string[]
  ) {
    super('Some projects could not be updated.', { cause })
  }
}
